import {DropdownMenu, type IconName} from '@wandb/components';
import React, {type ReactNode} from 'react';

type MenuItemProps = {
  children: ReactNode;
  icon?: IconName;
  id?: string;
  isDisabled?: boolean;
  onAction?: () => void;
};

export function MenuItem({
  children,
  icon,
  id,
  isDisabled,
  onAction,
}: MenuItemProps) {
  return (
    <DropdownMenu.Item id={id} onAction={onAction} isDisabled={isDisabled}>
      {icon ? <DropdownMenu.ItemDecorationLeft iconProps={{icon}} /> : null}
      <DropdownMenu.ItemLabel>{children}</DropdownMenu.ItemLabel>
    </DropdownMenu.Item>
  );
}
